// src/components/admin/ChangePasswordAdminModal.js

import React from 'react';
// +++ Se importan los componentes y los iconos necesarios para la nueva funcionalidad +++
import { Modal, Form, Input, message, Button, Tooltip, Space } from 'antd';
import { KeyOutlined, CopyOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';


// +++ INICIO: Función para generar contraseñas seguras (replicada de UserForm) +++
const generateSecurePassword = () => {
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '@$!%*#?&_-';
    
    let password = '';
    password += upper[Math.floor(Math.random() * upper.length)];
    password += lower[Math.floor(Math.random() * lower.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];

    const allChars = upper + lower + numbers + symbols;
    for (let i = password.length; i < 10; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    return password.split('').sort(() => 0.5 - Math.random()).join('');
};
// +++ FIN: Función para generar contraseñas seguras +++


const ChangePasswordAdminModal = ({ open, onCancel, onFinish, user, submitting }) => {
    const [form] = Form.useForm();
    // +++ Se usa Form.useWatch para observar el valor del campo de contraseña en tiempo real +++
    const passwordValue = Form.useWatch('newPassword', form);

    const handleOk = () => {
        form.validateFields()
            .then(values => {
                const payload = { newPassword: values.newPassword };
                onFinish(user._id, payload);
            })
            .catch(info => {
                message.warning('Por favor, complete todos los campos requeridos.');
                console.log('Validate Failed:', info);
            });
    };
    
    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    // +++ INICIO: Lógica para el generador y copiado de contraseñas +++
    const handleGeneratePassword = () => {
        const newPassword = generateSecurePassword();
        form.setFieldsValue({
            newPassword: newPassword,
            confirmNewPassword: newPassword,
        });
        message.info('Nueva contraseña generada.');
    };

    const handleCopyPassword = () => {
        const passwordToCopy = form.getFieldValue('newPassword');
        if (passwordToCopy) {
            navigator.clipboard.writeText(passwordToCopy);
            message.success('Contraseña copiada al portapapeles.');
        }
    };
    // +++ FIN: Lógica para el generador y copiado de contraseñas +++

    return (
        <Modal
            title={`Cambiar Contraseña para "${user?.username}"`}
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            okButtonProps={{ loading: submitting }}
            okText="Establecer Nueva Contraseña"
            cancelText="Cancelar"
            destroyOnClose 
        >
            <Form form={form} layout="vertical" name="admin_change_password_form" autoComplete="off">
                {/* +++ INICIO: Campo de contraseña mejorado con generador y botón de copiar +++ */}
                <Form.Item
                    label="Nueva Contraseña"
                    required
                >
                    <Space.Compact style={{ width: '100%' }}>
                        <Form.Item
                            name="newPassword"
                            noStyle
                            rules={[
                                { required: true, message: 'Por favor, ingrese la nueva contraseña.' },
                                { min: 6, message: 'La contraseña debe tener al menos 6 caracteres.' },
                                { 
                                    pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_-])[A-Za-z\d@$!%*#?&_-]{6,}$/,
                                    message: 'Debe incluir letras, números y al menos un carácter especial.'
                                }
                            ]}
                        >
                            <Input.Password 
                                placeholder="Ingrese o genere una contraseña"
                                iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                            />
                        </Form.Item>
                        <Tooltip title="Generar Contraseña Segura">
                            <Button icon={<KeyOutlined />} onClick={handleGeneratePassword} />
                        </Tooltip>
                        <Tooltip title="Copiar Contraseña">
                            <Button icon={<CopyOutlined />} onClick={handleCopyPassword} disabled={!passwordValue} />
                        </Tooltip>
                    </Space.Compact>
                </Form.Item>
                {/* +++ FIN: Campo de contraseña mejorado con generador y botón de copiar +++ */}

                <Form.Item
                    name="confirmNewPassword"
                    label="Confirmar Nueva Contraseña"
                    dependencies={['newPassword']}
                    hasFeedback
                    rules={[
                        { required: true, message: 'Por favor, confirme la nueva contraseña.' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Las dos contraseñas no coinciden.'));
                            },
                        }),
                    ]}
                >
                    <Input.Password 
                        placeholder="Confirme la nueva contraseña"
                        iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ChangePasswordAdminModal;
